import './initWebpackPublicPath'
import React, { useEffect } from 'react'
import i18n from './i18n'
import ReactDOM from 'react-dom/client'
import App from './App'
import reportWebVitals from './reportWebVitals'
import { registerPosServiceWorker } from './registerServiceWorker'
import { BrowserRouter, HashRouter } from 'react-router-dom'
import { Provider } from 'react-redux'
import { store } from './slices'
import { AuthSync } from 'slices/user/AuthSync'
import {
 installDeploymentUpdateWatcher,
 installGlobalChunkLoadRecoveryListener,
} from 'helpers/chunkLoadRecovery'
import { applyDocumentDirection } from 'helpers/locale'
import { hydrateUiZoom } from 'helpers/uiZoom'
import { restoreSpaRedirect } from 'helpers/spaRedirect'
import { startClientDiagnostics } from 'services/clientDiagnostics'

restoreSpaRedirect()
startClientDiagnostics()
hydrateUiZoom()
installGlobalChunkLoadRecoveryListener()
installDeploymentUpdateWatcher()

const LocaleWrapper = () => {
 useEffect(() => {
 applyDocumentDirection(i18n.language)
 const onLanguageChanged = (lng: string) => {
 applyDocumentDirection(lng)
 }
 i18n.on('languageChanged', onLanguageChanged)
 return () => {
 i18n.off('languageChanged', onLanguageChanged)
 }
 }, [])

 const isElectron =
 typeof window !== 'undefined' && Boolean((window as any)?.electronAPI?.isElectron)
 const Router = isElectron ? HashRouter : BrowserRouter

 const publicUrl = process.env.PUBLIC_URL ?? ''
 const basename = isElectron
 ? undefined
 : publicUrl === '.' || publicUrl === './' || publicUrl === '/' || !publicUrl
 ? ''
 : publicUrl.replace(/\/$/, '')

 return (
 <Router
 basename={basename}
 future={{
 v7_startTransition: true,
 v7_relativeSplatPath: true,
 }}
 >
 <AuthSync />
 <App />
 </Router>
 )
}

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement)
root.render(
 <Provider store={store}>
 <React.Fragment>
 <LocaleWrapper />
 </React.Fragment>
 </Provider>
)

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals()
registerPosServiceWorker()
